import { createContext, useContext, type PointerEvent } from "react";

type ErrorLogger = (
  options: {
    message: string;
    additional: Record<string, string | undefined>;
  },
  error: Error,
) => void;

type SupportLinkProps = {
  href: string;
  onClick: (e: PointerEvent<HTMLAnchorElement>) => void;
};

type Options = {
  logError: ErrorLogger;
  makeSupportLinkDeprecated?: (params: {
    traceId?: string;
    clientDebugId?: string;
  }) => SupportLinkProps;
  makeSupportLink?: (params: {
    traceId?: string;
    clientDebugId?: string;
  }) => SupportLinkProps;
};

const Context = createContext<Options>({
  logError: () => {},
});

export const ErrorBoundaryOptionsProvider = Context.Provider;

export const useErrorBoundaryOptions = () => useContext(Context);
